import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const ModalFiledPayment = ({ open, setOpen, selectedMembership }) => {
  const navigate = useNavigate();
  const handleClose = () => {
    navigate("/dashboard/account");
    setOpen(false);
  };
  return (
    <Dialog open={open}>
      <DialogContent sx={{ padding: 5 }}>
        <DialogTitle sx={{ textAlign: "center" }} variant="h5">
          Aún no se ha podido verificar su pago.
        </DialogTitle>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography sx={{ textAlign: "center" }}>
            Intente recargar la página en unos momentos. Si el pago no aparece,
            por favor contacte a nuestro equipo de soporte.
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Chip
              label={selectedMembership?.planName ?? "Free"}
              style={{
                backgroundColor: "#e7ef7d",
                color: "black",
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ textAlign: "center" }} variant="h4">
              ${selectedMembership?.price ?? "0"}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{ borderColor: "white", color: "white" }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalFiledPayment;
